var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
import './main.scss';
var defaultProps = {
    data: {
        title: 'TECHNOLOGY',
        headlineText: 'Tap into the power of Envestnet’s ecosystem with technology that’s',
    },
};
var CenteredHeadline = function (_a) {
    var _b = _a.data, title = _b.title, headlineText = _b.headlineText;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.centered-headline-section',
                start: 'top center',
            },
        });
        tl.fromTo(['.centered-headline-title', '.centered-headline-text'], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsxs("div", __assign({ className: "centered-headline-section text-enblue w-full snap-center relative" }, { children: [_jsx("p", __assign({ className: "centered-headline-title md:w-1/4 text-right" }, { children: title }), void 0),
            _jsx("div", __assign({ className: "centered-headline-title-line" }, { children: _jsx("hr", { className: "mt-[20px] md:w-1/4", style: { borderTop: 'solid 1px #005f9e' } }, void 0) }), void 0),
            _jsx("p", __assign({ className: "centered-headline-text justify-self-center" }, { children: headlineText }), void 0)] }), void 0));
};
export default CenteredHeadline;
